import { Autocomplete, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import API from '../../../../services/API'

// Reference-only medicine picker for an incident - no bag, no stock action.
// For medicines already administered as part of care, or already removed
// some other way, where the "remove from bag" flow (MedicineSelector.jsx)
// doesn't apply and can't even find them (it only lists live stock).
const MedicinesInvolvedList = ({ selected, setSelected }) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    API.get('/siteConfig/medicines')
      .then((res) => res.status === 200 && setOptions(res.data))
      .catch((e) => console.log(e))
  }, [])

  return (
    <Autocomplete
      multiple
      options={options}
      value={selected}
      isOptionEqualToValue={(opt, val) => opt._id === val._id}
      getOptionLabel={(opt) =>
        `${opt.title}${opt.constitution ? ` - ${opt.constitution}` : ''}`
      }
      onChange={(e, newValue) => setSelected(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Other medicines involved"
          helperText="Already administered, or already removed - no bag action needed here"
        />
      )}
    />
  )
}

export default MedicinesInvolvedList
